import { IExpandingSymbolFeatureState } from '@GFTypes/GameStoreTypes/ExpandingSymbolFeatureState';

export const EXPANDING_SYMBOL_FEATURE_STATE_DEFAULTS: IExpandingSymbolFeatureState = {
    isWinningExpandingSymbolPresent: false
};
